import AxiosService from './AxiosService';

class BillingService {
  /*
   * Singleton ES6 pattern
   * https://www.sitepoint.com/javascript-design-patterns-singleton/
   */
  constructor() {
    if (!BillingService.instance) {
      BillingService.instance = this;
    }
    return BillingService.instance;
  }

  endpoint = '/billing';

  async setDefaultPaymentMethod(paymentMethodId) {
    const res = await AxiosService.patch(
      `${this.endpoint}/payment/stripe/payment-methods/change-default-payment-method`,
      {
        default_payment_method_id: paymentMethodId,
      }
    );

    return res;
  }

  async deletePaymentMethod(paymentMethodId) {
    const res = await AxiosService.post(
      `${this.endpoint}/payment/stripe/payment-methods/${paymentMethodId}/detach`
    );

    return res;
  }
}

const instance = new BillingService();
Object.freeze(instance);

export default instance;
